export class OperationObjective {
    id?: number
    operationId: number = 0
    description: string = ""
    accomplished?: boolean

    parseObject(input: any) {
        this.id = input.id
        this.operationId = input.operationId
        this.description = input.description
        this.accomplished = input.accomplished
    }

    objectify(): object {
        return {
            id: this.id,
            operationId: this.operationId,
            description: this.description,
            accomplished: this.accomplished
        }
    }
}